import type { SvgIconComponent } from '@mui/icons-material';
import PeopleIcon from '@mui/icons-material/People';
import EditIcon from '@mui/icons-material/Edit';
import FolderIcon from '@mui/icons-material/Folder';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PaymentIcon from '@mui/icons-material/Payment';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import EmailIcon from '@mui/icons-material/Email';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventNoteIcon from '@mui/icons-material/EventNote';
import InsightsIcon from '@mui/icons-material/Insights';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SchoolIcon from '@mui/icons-material/School';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ReportIcon from '@mui/icons-material/Report';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export type AdminNavItem = {
  path: string;
  labelKey: string;
  icon: SvgIconComponent;
  /** Shown but not wired yet */
  comingSoon?: boolean;
  /** Hidden for limited admins (super admin only) */
  superAdminOnly?: boolean;
};

export type AdminNavSection = {
  sectionKey: string;
  items: AdminNavItem[];
};

export const ADMIN_NAV_SECTIONS: AdminNavSection[] = [
  {
    sectionKey: 'sidebar.sections.general',
    items: [
      { path: '/dashboard', labelKey: 'sidebar.dashboard', icon: DashboardIcon, superAdminOnly: true },
      { path: '/alerts', labelKey: 'sidebar.alerts', icon: NotificationsActiveIcon, superAdminOnly: true },
      { path: '/moderation', labelKey: 'sidebar.moderation', icon: ReportIcon, superAdminOnly: true },
      { path: '/users', labelKey: 'sidebar.users', icon: PeopleIcon },
      { path: '/behavior', labelKey: 'sidebar.behavior', icon: InsightsIcon },
      { path: '/finance', labelKey: 'sidebar.finance', icon: AccountBalanceIcon, superAdminOnly: true },
      { path: '/teachers', labelKey: 'sidebar.teachers', icon: SchoolIcon },
      { path: '/sessions', labelKey: 'sidebar.sessions', icon: EventNoteIcon },
    ],
  },
  {
    sectionKey: 'sidebar.sections.content',
    items: [
      { path: '/page-editor', labelKey: 'sidebar.pageEditor', icon: EditIcon },
      { path: '/files', labelKey: 'sidebar.files', icon: FolderIcon },
      { path: '/playbacks', labelKey: 'sidebar.playbacks', icon: LibraryMusicIcon },
      { path: '/exercises', labelKey: 'sidebar.exercises', icon: FitnessCenterIcon },
      { path: '/formations', labelKey: 'sidebar.formations', icon: MenuBookIcon },
    ],
  },
  {
    sectionKey: 'sidebar.sections.platform',
    items: [
      { path: '/progression', labelKey: 'sidebar.progression', icon: TrendingUpIcon, superAdminOnly: true },
      { path: '/subscription-plans', labelKey: 'sidebar.subscriptionPlans', icon: CardMembershipIcon, superAdminOnly: true },
      { path: '/payment-gateway', labelKey: 'sidebar.paymentGateway', icon: PaymentIcon, superAdminOnly: true },
    ],
  },
  {
    sectionKey: 'sidebar.sections.system',
    items: [
      { path: '/jobs', labelKey: 'sidebar.jobs', icon: WorkHistoryIcon, superAdminOnly: true },
      { path: '/emails', labelKey: 'sidebar.emailTesting', icon: EmailIcon, superAdminOnly: true },
    ],
  },
];
